import React from 'react';
import parse from 'date-fns/parse';
import { useSelector } from 'react-redux';

export const StoreSchema = ({ store }) => {
  const {
    storeName,
    city,
    state,
    postcode,
    telephone,
    coordinates,
    address1,
    address2,
    country,
  } = store;

  const context = useSelector((state) => state.app.context);

  const formatTime = (time) => {
    let dt = parse(time, 'hh:mm a', new Date());
    if (isNaN(dt)) {
      dt = parse(time, 'hh.mma', new Date());
    }

    if (isNaN(dt)) {
      return time;
    } else {
      return dt.toLocaleTimeString();
    }
  };

  const storeUrl = context.projectConfiguration['EXTENSION_PUBLIC_URL'];
  const openingHoursSpecification = [];

  const address = `${address1} ${address2 && address2 + ','} ${
    city && city + ','
  } ${state} ${postcode}`;

  const days = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];

  days.forEach((el) => {
    if (
      !store[`hours_${el.slice(0, 3)}_open`] ||
      !store[`hours_${el.slice(0, 3)}_close`]
    )
      return;

    const formattedDay = el.slice(0, 1).toUpperCase() + el.slice(1);
    const openingTime = store[`hours_${el.slice(0, 3)}_open`];
    const closingTime = store[`hours_${el.slice(0, 3)}_close`];

    openingHoursSpecification.push({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: formattedDay,
      opens: formatTime(openingTime),
      closes: formatTime(closingTime),
    });
  });

  const schema = {
    '@context': 'http://schema.org',
    '@type': 'Store',
    name: storeName,
    address: {
      '@type': 'PostalAddress',
      streetAddress: address,
      addressLocality: city,
      addressRegion: state,
      postalCode: postcode,
      addressCountry: country,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: coordinates.lat,
      longitude: coordinates.lng,
    },
    url: storeUrl,
    telephone: telephone,
    openingHoursSpecification: openingHoursSpecification,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
